import {UnstableCard as Paper} from '@logistics-frontend/blocks'
import {merge} from '@logistics-frontend/utils'
import React, {memo} from 'react'

import {renderWidget} from '..'
import {WidgetPropsByType, WidgetType} from '../types'
import {PaymentCard} from './components/PaymentCard/index@mobile'
import {useGetBody} from './hooks/useGetBody'

export const PaymentMethod = memo(
  ({additional_body, title_style, widget_id}: WidgetPropsByType<WidgetType.PAYMENT_METHOD>): React.ReactElement => {
    const getBody = useGetBody()

    return (
      <Paper padding="none" radius="L">
        <PaymentCard
          getBody={getBody}
          name={widget_id}
          title={additional_body.title.items.map(item =>
            renderWidget(merge(item, {color: title_style.color, font_size: title_style.size})),
          )}
        />
      </Paper>
    )
  },
)
